module.exports = {
      id: "ic-50-index-usage",
      viewBox: "0 0 33 32",
      url: __webpack_public_path__ + "sprite-dbc6d5.smartcharts.svg#ic-50-index-usage",
      toString: function () {
        return this.url;
      }
    }